import React from 'react';
import { mdiOpenInNew, mdiCursorDefaultClick } from '@mdi/js';
import { Button, Tooltip, Flex } from 'antd';
import useQueryParams from 'hooks/useQueryParams';
import Icon from '@mdi/react';
import { useHistory } from 'react-router-dom';
import P from 'router/paths';

const AnonymousUserFormatter = ({ row }) => {
  const { setUrlParams } = useQueryParams();
  const history = useHistory();

  if (!row?.user_id) {
    return '-';
  }

  const handleNavigateToUserJourney = () => {
    history.push(P.REPORT.USER_JOURNEY);
    setUrlParams({ user_id: row.user_id });
  };

  return (
    <Flex align='center' gap='small'>
      <Tooltip title='See user actions: ads viewed, pages clicked'>
        <Button
          className=''
          size='small'
          onClick={handleNavigateToUserJourney}
          icon={<Icon path={mdiCursorDefaultClick} size={0.7} />}
          iconPosition='end'
        >
          Anonymous User <img src='/icons/anonymous.svg' className='h-5 mr-1' />
        </Button>
      </Tooltip>

      <span className='text-gray ml-1'>|</span>

      <Tooltip title='Open User Journey'>
        <Button
          type='text'
          size='small'
          shape='circle'
          className='group !p-0'
          onClick={() => setUrlParams({ report: 'user_journey', user_id: row.user_id })}
          icon={<Icon path={mdiOpenInNew} size={0.7} />}
        />
      </Tooltip>
    </Flex>
  );
};

export default AnonymousUserFormatter;
